export default function maskEmail(email) {
  const [userName, mailServer] = email.split('@');

  const firstLetter = userName.slice(0, 1);

  const lastLetter = userName.slice(-1);

  const asterisks = '*'.repeat(userName.length - 2);

  return `${firstLetter}${asterisks}${lastLetter}@${mailServer}`;
}
